export default __webpack_public_path__ + "static/media/FPBSOL_Notas_as_Contas_2022.d0e53206.pdf";